import { render } from "./G01IconRanking.vue?vue&type=template&id=12b3e98a&scoped=true&ts=true"
import script from "./G01IconRanking.vue?vue&type=script&lang=ts"
export * from "./G01IconRanking.vue?vue&type=script&lang=ts"

import "./G01IconRanking.vue?vue&type=style&index=0&id=12b3e98a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12b3e98a"]])

export default __exports__